import React from 'react';
import PropTypes from 'prop-types';
import HeaderPortal from 'components/layout/HeaderPortal';
import GenericEntityFlowListBrowser from './GenericEntityFlowListBrowser';
import { entityContextPath, entityContextPermissions } from '../../utils';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { withAreaGetter } from 'providers/AreasConsumers';
import PermissionCheck from 'components/common/PermissionCheck';
import Portal from 'utils/portal/Portal';
import IconButton from 'components/common/buttons/IconButton';
import { areas } from 'constants/areas';

const Route = ({ entityContext, getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  const onAdd = () => {
    historyContext.push(`/${entityContextPath[entityContext]}/new`);
  };

  return (
    <>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        {
          <PermissionCheck authorizationCode={entityContextPermissions[entityContext]?.write} withForbiddenPage={false}>
            <IconButton type='add' size='medium' onClick={onAdd} />
          </PermissionCheck>
        }
      </Portal>
      <PermissionCheck authorizationCode={entityContextPermissions[entityContext]?.read}>
        <GenericEntityFlowListBrowser entityContext={entityContext} />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  entityContext: PropTypes.string,
  getElemByAreaKey: PropTypes.func
};

export default withAreaGetter(Route);
